import gql from "graphql-tag";

const MUTATE_LINK_JOB_CARDS_TO_JOB_CARD_MASTER = gql`
  mutation ($affiliate: String, $id: Int, $jobCardIds: [Int]) {
    linkJobCardsToJobCardMaster(affiliate: $affiliate, id: $id, jobCardIds: $jobCardIds)
  }
`;

export { MUTATE_LINK_JOB_CARDS_TO_JOB_CARD_MASTER };
